"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeResponse_1 = require("./makeResponse");
var HttpRequestDazn = /** @class */ (function () {
    function HttpRequestDazn(id, xhr, httpRequestMonitor, shaka, params) {
        this.id = id;
        this.xhr = xhr;
        this.httpRequestMonitor = httpRequestMonitor;
        this.shaka = shaka;
        this.params = params;
        this.hasTimedOutFlag = false;
    }
    HttpRequestDazn.prototype.open = function () {
        var _this = this;
        var promise = new Promise(function (resolve, reject) {
            _this.httpRequestMonitor.onHttpRequestOpen(_this);
            var _a = _this.params, uri = _a.uri, request = _a.request;
            var xhr = _this.xhr;
            xhr.open(request.method, uri, true);
            xhr.responseType = 'arraybuffer';
            xhr.timeout = request.retryParameters.timeout;
            xhr.withCredentials = request.allowCrossSiteCredentials;
            xhr.onprogress = _this.onProgress.bind(_this);
            xhr.onload = _this.onLoad.bind(_this, resolve, reject);
            xhr.onabort = _this.onAbort.bind(_this, reject);
            xhr.onerror = _this.onError.bind(_this, reject);
            xhr.ontimeout = _this.onTimeout.bind(_this, reject);
            for (var key in request.headers) {
                var lowerCaseKey = key.toLowerCase();
                var value = request.headers[key];
                xhr.setRequestHeader(lowerCaseKey, value);
            }
            xhr.send(request.body);
        });
        return promise;
    };
    HttpRequestDazn.prototype.abort = function () {
        this.xhr.abort();
    };
    HttpRequestDazn.prototype.timeout = function () {
        this.hasTimedOutFlag = true;
        this.abort();
    };
    HttpRequestDazn.prototype.hasTimedOut = function () {
        return this.hasTimedOutFlag;
    };
    HttpRequestDazn.prototype.getRequestType = function () {
        return this.params.requestType;
    };
    HttpRequestDazn.prototype.onProgress = function (event) {
        this.httpRequestMonitor.onHttpRequestProgress(this, event.loaded, event.total);
    };
    HttpRequestDazn.prototype.onLoad = function (resolve, reject, event) {
        var target = event.target;
        var responseHeaders = target.getAllResponseHeaders();
        var headers = responseHeaders.trim().split('\r\n').reduce(function (all, part) {
            var header = part.split(': ');
            var key = header[0].toLowerCase();
            all[key] = header.slice(1).join(': ');
            return all;
        }, {});
        var _a = this.params, uri = _a.uri, requestType = _a.requestType;
        try {
            var response = makeResponse_1.default(this.shaka, headers, target.response, target.status, uri, target.responseURL, requestType);
            this.httpRequestMonitor.onHttpRequestLoad(this);
            resolve(response);
        }
        catch (error) {
            this.httpRequestMonitor.onHttpRequestError(this);
            reject(error);
        }
    };
    HttpRequestDazn.prototype.onAbort = function (reject) {
        if (this.hasTimedOutFlag) {
            this.onTimeout(reject);
        }
        else {
            this.httpRequestMonitor.onHttpRequestAbort(this);
            var shaka = this.shaka;
            var _a = this.params, uri = _a.uri, requestType = _a.requestType;
            reject(new shaka.util.Error(shaka.util.Error.Severity.RECOVERABLE, shaka.util.Error.Category.NETWORK, shaka.util.Error.Code.OPERATION_ABORTED, uri, requestType));
        }
    };
    HttpRequestDazn.prototype.onError = function (reject, event) {
        this.httpRequestMonitor.onHttpRequestError(this);
        var shaka = this.shaka;
        var _a = this.params, uri = _a.uri, requestType = _a.requestType;
        reject(new shaka.util.Error(shaka.util.Error.Severity.RECOVERABLE, shaka.util.Error.Category.NETWORK, shaka.util.Error.Code.HTTP_ERROR, uri, event, requestType));
    };
    HttpRequestDazn.prototype.onTimeout = function (reject) {
        this.httpRequestMonitor.onHttpRequestTimeout(this);
        var shaka = this.shaka;
        var _a = this.params, uri = _a.uri, requestType = _a.requestType;
        reject(new shaka.util.Error(shaka.util.Error.Severity.RECOVERABLE, shaka.util.Error.Category.NETWORK, shaka.util.Error.Code.TIMEOUT, uri, requestType));
    };
    return HttpRequestDazn;
}());
exports.default = HttpRequestDazn;
//# sourceMappingURL=HttpRequestDazn.js.map